import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const Container = styled.div`
    display: block;
`

export const Group = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media (min-width: ${theme.breakpoints[0]}) {
        align-items: flex-start;
        flex-direction: row;
        padding: 0;
        gap: 1.25rem;
    }
`

export const Img = styled.img`
    display: block;
    height: 100%;
    max-height: 1.667rem;
    margin: 0 auto;
    transform: scale(0.8);

    @media (min-width: ${theme.breakpoints[0]}) {
        transform: scale(1);
    }
`

export const Title = styled.h3`
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 700;
    text-align: left;
    width: 100%;

    @media (min-width: ${theme.breakpoints[0]}) {
        text-align: center;
        padding-top: 0.917rem;
    }
`

export const Text = styled.p`
    font-size: 0.813rem;
    line-height: 1.381rem;
    font-weight: 400;
    text-align: left;
    padding: 0;

    @media (min-width: ${theme.breakpoints[0]}) {
        text-align: center;
        padding-top: 0.5rem;
        margin: auto;
    }

    @media (max-width: 360px) {
        max-width: 13.125rem;
    }

    @media (min-width: 744px) {
        max-width: 9.125rem;
    }

    @media (min-width: ${theme.breakpoints[1]}) {
        max-width: 13rem;
    }
`

export const Topic = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: start;

    &:not(:first-child) {
        margin-top: 2.5rem;
    }

    @media (min-width: ${theme.breakpoints[0]}) {
        flex-direction: column;
        justify-content: center;
        &:not(:first-child) {
            margin-top: 0;
        }
    }
`

export const ImgCircle = styled.div`
    background: #e6ebff;
    margin: 0.313;
    color: white;
    flex: 1 0 auto;
    border-radius: 50%;
    max-width: 2.875rem;
    max-height: 2.875rem;
    min-width: 2.875rem;
    justify-content: center;
    align-items: center;
    display: flex;
    margin-right: 1.25rem;

    &:before {
        content: '';
        float: left;
        padding-top: 100%;
    }

    @media (min-width: ${theme.breakpoints[0]}) {
        background-color: transparent;
        margin-right: 0;
    }
`
